module.exports = __webpack_public_path__ + "img/9.32eeb643.jpg";